export const authorization = 'Authorization';
export const RegistData = 'RegistData';
export const DroneDiagnosisData = 'DroneDiagnosisData';
